// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file plataforma_terceros_clientes.proto (package sextante.plataforma.terceros.clientes.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file plataforma_terceros_clientes.proto.
 */
export const file_plataforma_terceros_clientes: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * Sin delta: Plataforma no guarda nada local y siempre pide la lista completa, asi que el
 * servidor ya excluye los eliminados en vez de mandarlos marcados.
 *
 * @generated from message sextante.plataforma.terceros.clientes.v1.ListClientesPlataformaRequest
 */
export type ListClientesPlataformaRequest = Message<"sextante.plataforma.terceros.clientes.v1.ListClientesPlataformaRequest"> & {
};

/**
 * Describes the message sextante.plataforma.terceros.clientes.v1.ListClientesPlataformaRequest.
 * Use `create(ListClientesPlataformaRequestSchema)` to create a new message.
 */
export const ListClientesPlataformaRequestSchema: GenMessage<ListClientesPlataformaRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_clientes, 0);

/**
 * Clientes no eliminados.
 *
 * @generated from message sextante.plataforma.terceros.clientes.v1.ListClientesPlataformaResponse
 */
export type ListClientesPlataformaResponse = Message<"sextante.plataforma.terceros.clientes.v1.ListClientesPlataformaResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.terceros.clientes.v1.ClientePlataformaItem items = 1;
   */
  items: ClientePlataformaItem[];
};

/**
 * Describes the message sextante.plataforma.terceros.clientes.v1.ListClientesPlataformaResponse.
 * Use `create(ListClientesPlataformaResponseSchema)` to create a new message.
 */
export const ListClientesPlataformaResponseSchema: GenMessage<ListClientesPlataformaResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_clientes, 1);

/**
 * Cliente con su licencia y sus totales.
 *
 * @generated from message sextante.plataforma.terceros.clientes.v1.ClientePlataformaItem
 */
export type ClientePlataformaItem = Message<"sextante.plataforma.terceros.clientes.v1.ClientePlataformaItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string nit = 2;
   */
  nit: string;

  /**
   * @generated from field: string nombre = 3;
   */
  nombre: string;

  /**
   * @generated from field: string email = 4;
   */
  email: string;

  /**
   * @generated from field: string telefono = 5;
   */
  telefono: string;

  /**
   * true si la licencia es de demostracion.
   *
   * @generated from field: bool is_demo_plataforma = 6;
   */
  isDemoPlataforma: boolean;

  /**
   * Unix ms
   *
   * @generated from field: optional int64 fecha_vencimiento_plataforma = 7;
   */
  fechaVencimientoPlataforma?: bigint | undefined;

  /**
   * Hectareas que permite la licencia.
   *
   * @generated from field: int32 maximo_hectareas_plataforma = 8;
   */
  maximoHectareasPlataforma: number;

  /**
   * GPS trackers asignados al cliente.
   *
   * @generated from field: int32 cant_dispositivos = 9;
   */
  cantDispositivos: number;

  /**
   * @generated from field: int32 cant_fincas = 10;
   */
  cantFincas: number;

  /**
   * Suma de hectareas de sus fincas activas.
   *
   * @generated from field: double hectareas_totales = 11;
   */
  hectareasTotales: number;

  /**
   * Promotor que lleva al cliente, si tiene.
   *
   * @generated from field: optional string promotor_id = 12;
   */
  promotorId?: string | undefined;

  /**
   * @generated from field: optional string promotor_nombre = 13;
   */
  promotorNombre?: string | undefined;

  /**
   * Para el asistente de Proyectos (2026-10-28, antes en BuscarClientes). Solo los llena ListClientes: en las
   * respuestas de un solo cliente (GuardarCliente, AsignarPlan, GetClienteDetalle) van vacios.
   * Municipio de alguna de sus fincas activas, si tiene.
   *
   * @generated from field: optional string ubicacion = 14;
   */
  ubicacion?: string | undefined;

  /**
   * Nucleo de su proyecto mas reciente, si tiene.
   *
   * @generated from field: optional string nucleo_asignado = 15;
   */
  nucleoAsignado?: string | undefined;

  /**
   * Proyectos activos del cliente.
   *
   * @generated from field: int32 proyectos_activos = 16;
   */
  proyectosActivos: number;
};

/**
 * Describes the message sextante.plataforma.terceros.clientes.v1.ClientePlataformaItem.
 * Use `create(ClientePlataformaItemSchema)` to create a new message.
 */
export const ClientePlataformaItemSchema: GenMessage<ClientePlataformaItem> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_clientes, 2);

/**
 * Cliente del que se pide la ficha.
 *
 * @generated from message sextante.plataforma.terceros.clientes.v1.GetClienteDetallePlataformaRequest
 */
export type GetClienteDetallePlataformaRequest = Message<"sextante.plataforma.terceros.clientes.v1.GetClienteDetallePlataformaRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message sextante.plataforma.terceros.clientes.v1.GetClienteDetallePlataformaRequest.
 * Use `create(GetClienteDetallePlataformaRequestSchema)` to create a new message.
 */
export const GetClienteDetallePlataformaRequestSchema: GenMessage<GetClienteDetallePlataformaRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_clientes, 3);

/**
 * Ficha del cliente. Sin delta ni eliminados.
 *
 * @generated from message sextante.plataforma.terceros.clientes.v1.ClienteDetallePlataformaResponse
 */
export type ClienteDetallePlataformaResponse = Message<"sextante.plataforma.terceros.clientes.v1.ClienteDetallePlataformaResponse"> & {
  /**
   * @generated from field: sextante.plataforma.terceros.clientes.v1.ClientePlataformaItem cliente = 1;
   */
  cliente?: ClientePlataformaItem | undefined;

  /**
   * Solo las activas del cliente, ordenadas por nombre.
   *
   * @generated from field: repeated sextante.plataforma.terceros.clientes.v1.FincaResumenPlataformaItem fincas = 2;
   */
  fincas: FincaResumenPlataformaItem[];

  /**
   * No eliminadas; las que administran usuarios primero. Vacia para quien no administra las cuentas de la app (en
   * Nitrofert, todos).
   *
   * @generated from field: repeated sextante.plataforma.terceros.clientes.v1.UsuarioAppPlataformaItem usuarios_app = 3;
   */
  usuariosApp: UsuarioAppPlataformaItem[];

  /**
   * Solo los GPS trackers de este cliente, por codigo_cliente y codigo_interno.
   *
   * @generated from field: repeated sextante.plataforma.terceros.clientes.v1.DispositivoPlataformaItem dispositivos = 4;
   */
  dispositivos: DispositivoPlataformaItem[];
};

/**
 * Describes the message sextante.plataforma.terceros.clientes.v1.ClienteDetallePlataformaResponse.
 * Use `create(ClienteDetallePlataformaResponseSchema)` to create a new message.
 */
export const ClienteDetallePlataformaResponseSchema: GenMessage<ClienteDetallePlataformaResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_clientes, 4);

/**
 * Solo lo que pinta la card de la pestana Fincas: la ficha pide la finca completa aparte
 * (FincasPlataformaService.GetFicha), asi que aca no viajan geometrias ni el resto de campos.
 *
 * @generated from message sextante.plataforma.terceros.clientes.v1.FincaResumenPlataformaItem
 */
export type FincaResumenPlataformaItem = Message<"sextante.plataforma.terceros.clientes.v1.FincaResumenPlataformaItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string nombre_finca = 2;
   */
  nombreFinca: string;

  /**
   * @generated from field: optional string municipio_nombre = 3;
   */
  municipioNombre?: string | undefined;

  /**
   * @generated from field: optional string departamento_nombre = 4;
   */
  departamentoNombre?: string | undefined;

  /**
   * @generated from field: double hectareas_finca = 5;
   */
  hectareasFinca: number;

  /**
   * Nombres distintos de los cultivos de sus lotes no eliminados, ordenados.
   *
   * @generated from field: repeated string cultivos = 6;
   */
  cultivos: string[];
};

/**
 * Describes the message sextante.plataforma.terceros.clientes.v1.FincaResumenPlataformaItem.
 * Use `create(FincaResumenPlataformaItemSchema)` to create a new message.
 */
export const FincaResumenPlataformaItemSchema: GenMessage<FincaResumenPlataformaItem> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_clientes, 5);

/**
 * Solo lo que usa la pestana Usuarios (lista y modal de edicion).
 *
 * @generated from message sextante.plataforma.terceros.clientes.v1.UsuarioAppPlataformaItem
 */
export type UsuarioAppPlataformaItem = Message<"sextante.plataforma.terceros.clientes.v1.UsuarioAppPlataformaItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string nombre = 2;
   */
  nombre: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: bool is_activo = 4;
   */
  isActivo: boolean;

  /**
   * @generated from field: bool has_usuarios = 5;
   */
  hasUsuarios: boolean;
};

/**
 * Describes the message sextante.plataforma.terceros.clientes.v1.UsuarioAppPlataformaItem.
 * Use `create(UsuarioAppPlataformaItemSchema)` to create a new message.
 */
export const UsuarioAppPlataformaItemSchema: GenMessage<UsuarioAppPlataformaItem> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_clientes, 6);

/**
 * Solo lo que pinta la pestana Dispositivos. De la fecha de testeo solo importa si existe.
 *
 * @generated from message sextante.plataforma.terceros.clientes.v1.DispositivoPlataformaItem
 */
export type DispositivoPlataformaItem = Message<"sextante.plataforma.terceros.clientes.v1.DispositivoPlataformaItem"> & {
  /**
   * @generated from field: int32 codigo_interno = 1;
   */
  codigoInterno: number;

  /**
   * @generated from field: int32 codigo_cliente = 2;
   */
  codigoCliente: number;

  /**
   * @generated from field: bool testeado = 3;
   */
  testeado: boolean;

  /**
   * @generated from field: bool pasa_test = 4;
   */
  pasaTest: boolean;

  /**
   * @generated from field: optional string nota_test = 5;
   */
  notaTest?: string | undefined;
};

/**
 * Describes the message sextante.plataforma.terceros.clientes.v1.DispositivoPlataformaItem.
 * Use `create(DispositivoPlataformaItemSchema)` to create a new message.
 */
export const DispositivoPlataformaItemSchema: GenMessage<DispositivoPlataformaItem> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_clientes, 7);

/**
 * Cliente a crear o editar.
 *
 * @generated from message sextante.plataforma.terceros.clientes.v1.GuardarClientePlataformaRequest
 */
export type GuardarClientePlataformaRequest = Message<"sextante.plataforma.terceros.clientes.v1.GuardarClientePlataformaRequest"> & {
  /**
   * @generated from field: optional string id = 1;
   */
  id?: string | undefined;

  /**
   * @generated from field: string nit = 2;
   */
  nit: string;

  /**
   * @generated from field: string razon_social = 3;
   */
  razonSocial: string;

  /**
   * @generated from field: string email = 4;
   */
  email: string;

  /**
   * @generated from field: string telefono = 5;
   */
  telefono: string;

  /**
   * @generated from field: optional string promotor_id = 6;
   */
  promotorId?: string | undefined;
};

/**
 * Describes the message sextante.plataforma.terceros.clientes.v1.GuardarClientePlataformaRequest.
 * Use `create(GuardarClientePlataformaRequestSchema)` to create a new message.
 */
export const GuardarClientePlataformaRequestSchema: GenMessage<GuardarClientePlataformaRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_clientes, 8);

/**
 * Licencia a asignar: demo o plan real.
 *
 * @generated from message sextante.plataforma.terceros.clientes.v1.AsignarPlanPlataformaRequest
 */
export type AsignarPlanPlataformaRequest = Message<"sextante.plataforma.terceros.clientes.v1.AsignarPlanPlataformaRequest"> & {
  /**
   * @generated from field: string cliente_id = 1;
   */
  clienteId: string;

  /**
   * @generated from field: bool is_demo = 2;
   */
  isDemo: boolean;

  /**
   * Obligatorios si is_demo = false; se ignoran en demo.
   *
   * Unix ms
   *
   * @generated from field: optional int64 fecha_vencimiento = 3;
   */
  fechaVencimiento?: bigint | undefined;

  /**
   * > 0
   *
   * @generated from field: optional int32 maximo_hectareas = 4;
   */
  maximoHectareas?: number | undefined;
};

/**
 * Describes the message sextante.plataforma.terceros.clientes.v1.AsignarPlanPlataformaRequest.
 * Use `create(AsignarPlanPlataformaRequestSchema)` to create a new message.
 */
export const AsignarPlanPlataformaRequestSchema: GenMessage<AsignarPlanPlataformaRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_clientes, 9);

/**
 * Clientes de la app Plataforma, menu Clientes. Logica propia del servicio gRPC, sin la capa vieja de
 * servicios. Requiere sesion de Plataforma.
 *
 * @generated from service sextante.plataforma.terceros.clientes.v1.ClientesPlataformaService
 */
export const ClientesPlataformaService: GenService<{
  /**
   * Clientes no eliminados, con sus totales de fincas, hectareas y dispositivos, y lo que muestra el asistente de
   * Proyectos. Un promotor recibe solo su cartera. Todos los buscadores de clientes de la Plataforma buscan sobre esta
   * lista, en el navegador (2026-10-28: se borro BuscarClientes).
   *
   * @generated from rpc sextante.plataforma.terceros.clientes.v1.ClientesPlataformaService.ListClientes
   */
  listClientes: {
    methodKind: "unary";
    input: typeof ListClientesPlataformaRequestSchema;
    output: typeof ListClientesPlataformaResponseSchema;
  },
  /**
   * Ficha del cliente: datos, fincas, cuentas y dispositivos. NotFound si el cliente no existe o esta
   * eliminado.
   *
   * @generated from rpc sextante.plataforma.terceros.clientes.v1.ClientesPlataformaService.GetClienteDetalle
   */
  getClienteDetalle: {
    methodKind: "unary";
    input: typeof GetClienteDetallePlataformaRequestSchema;
    output: typeof ClienteDetallePlataformaResponseSchema;
  },
  /**
   * Sin id crea, con id edita (NotFound si no existe). Validaciones de negocio -> InvalidArgument con el
   * motivo.
   *
   * @generated from rpc sextante.plataforma.terceros.clientes.v1.ClientesPlataformaService.GuardarCliente
   */
  guardarCliente: {
    methodKind: "unary";
    input: typeof GuardarClientePlataformaRequestSchema;
    output: typeof ClientePlataformaItemSchema;
  },
  /**
   * Asigna la licencia del cliente. Demo: 30 dias desde hoy, 0 hectareas. Plan real:
   * fecha y hectareas (> 0) obligatorias. Si el cliente no tiene cuenta en la app web, la crea y
   * encola el correo de bienvenida con la contrasena generada.
   *
   * @generated from rpc sextante.plataforma.terceros.clientes.v1.ClientesPlataformaService.AsignarPlan
   */
  asignarPlan: {
    methodKind: "unary";
    input: typeof AsignarPlanPlataformaRequestSchema;
    output: typeof ClientePlataformaItemSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_plataforma_terceros_clientes, 0);

